import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Profile from '../components/Profile'

import { actionCreators } from '../actions'

const mapStateToProps = (state) => ({
  customer: state.customer, // gives our component access to state through props
  cartStatus: state.cart.cartStatus,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
